import { render, staticRenderFns } from "./ResellerModuleMenu.vue?vue&type=template&id=3f8ce0de&"
import script from "./ResellerModuleMenu.vue?vue&type=script&lang=js&"
export * from "./ResellerModuleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports